// extracted by mini-css-extract-plugin
export var container = "_gi-1";
export var editor = "_gi-2";
export var resizable = "_gi-3";
export var wrapper = "_gi-0";